import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
  output,
} from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { FileService } from '@ipg/ngx-frontend-toolset';
import { AvatarComponent } from '../../../../components/avatar/avatar.component';
import { HighlightVariablesPipe } from '../../../../pipes/highlight-variables.pipe';
import { AnswerTreeNode } from '../../../interaction-editor/interaction-editor.component';
import { FlowAudioActionComponent } from './actions/flow-audio-action/flow-audio-action.component';
import { FlowGotoInteractionActionComponent } from './actions/flow-goto-interaction-action/flow-goto-interaction-action.component';
import { FlowGotoQuestionActionComponent } from './actions/flow-goto-question-action/flow-goto-question-action.component';
import { FlowImageActionComponent } from './actions/flow-image-action/flow-image-action.component';
import { FlowNotificationSmsActionComponent } from './actions/flow-notification-sms-action/flow-notification-sms-action.component';
import { FlowSpeakActionComponent } from './actions/flow-speak-action/flow-speak-action.component';
import { FlowStopActionComponent } from './actions/flow-stop-action/flow-stop-action.component';

@Component({
  selector: 'app-flow-answer-node',
  imports: [
    MatIconModule,
    AvatarComponent,
    HighlightVariablesPipe,
    FlowSpeakActionComponent,
    FlowAudioActionComponent,
    FlowImageActionComponent,
    FlowNotificationSmsActionComponent,
    FlowStopActionComponent,
    FlowGotoQuestionActionComponent,
    FlowGotoInteractionActionComponent,
  ],
  templateUrl: './flow-answer-node.component.html',
  styleUrl: './flow-answer-node.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FlowAnswerNodeComponent {
  private readonly _fileService = inject(FileService);

  readonly data = input.required<AnswerTreeNode>();
  /**
   * Maps interaction ID → first question node ID, used to resolve
   * goto-interaction targets into pannable node IDs.
   */
  readonly gotoInteractionTargetMap = input<Map<string, string>>(new Map());
  /**
   * Maps question ID → question label, used to resolve
   * goto-question targets into human-readable labels.
   */
  readonly gotoQuestionLabelMap = input<Map<string, string>>(new Map());
  readonly panToNode = output<string>();

  protected readonly answerLabel = computed(() => {
    const answer = this.data();
    return answer.type === 'image' ? answer.value.label : answer.value;
  });

  protected getFileUrl(fileId: string): string {
    return this._fileService.get(fileId).href;
  }

  protected getGotoTargetId(action: any): string {
    if (!action?.value) return '';
    return typeof action.value === 'string'
      ? action.value
      : action.value._id || action.value.id || '';
  }
}
